
import { Module } from '../core';

import setCenter from './commands/setCenter';
import setLayerVisibility from './commands/setLayerVisibility';
import zoomIn from './commands/zoomIn';
import zoomOut from './commands/zoomOut';

export default class ModuleMap extends Module {

    constructor() {
        super('map');
        this._serverApiUrl = '';
    }

    getServerApiUrl() {
        return this._serverApiUrl;
    }

    async init(options) {
        super.init(options);
        this._serverApiUrl = options.serverApiUrl;
    }

    initCommands() {
        this.addCommand(setCenter);
        this.addCommand(setLayerVisibility);
        this.addCommand(zoomIn);
        this.addCommand(zoomOut);
    }
}
